import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Reward
export const fetchReward = createAsyncThunk(
  "reward/fetchReward",
  async ({ page = 1, search = "", fetchAll = false }, { rejectWithValue, getState }) => {
    try {
      const { reward } = getState();
      const { pageSize , cache} = reward;

        const cacheKey = `${page}_${search}_${pageSize}_${fetchAll}`;

      // ✅ cache check
      if (cache[cacheKey]) {
        return {
          data: cache[cacheKey],
          page,
          search,
          pageSize,
          fromCache: true,
        };
      }



      let url = `/transaction/panel/Reward`;

      if (!fetchAll) {
        url += `?page=${page}&page_size=${pageSize}`;
      } else {
        url += `?page=1&page_size=10000`; // huge number to get all users
      }

      if (search) {
        url += `&search=${search}`;
      }

      const response = await api.get(url);

      return {
        data: response.data,
        page,
        search,
        pageSize,
        fromCache: false,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);




// Add Reward
export const addReward = createAsyncThunk(
  "reward/addReward",
  async (newReward, { rejectWithValue }) => {
    try {
      const response = await api.post("/transaction/panel/Reward", newReward);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Reward
export const updateReward = createAsyncThunk(
  "reward/updateReward",
  async (rewardData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/transaction/panel/Reward", rewardData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Reward Slice
const rewardSlice = createSlice({
  name: "reward",
  initialState: {
    rewardList: { result: [], pagination: { total_pages: 1 } },
    search: "", // ✅ NEW
    currentPage: 1,
    pageSize: 10, // ✅ controlled here
    totalPages: 1,
    cache: {}, // store data per page
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },

      setPage: (state, action) => {
      state.currentPage = action.payload;
    },

      setPageSize: (state, action) => { 
      state.pageSize = action.payload;
      state.currentPage = 1; 
      state.cache = {}; 
    },
  
      // ✅ ADD THIS
     clearCache: (state) => {
      state.cache = {};
      }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Reward
      .addCase(fetchReward.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchReward.fulfilled, (state, action) => {
         const { data, page, search, pageSize, fromCache } = action.payload;

         const cacheKey = `${page}_${search}_${pageSize}_${false}`;

        // ✅ Save in cache if not cached already
        if (!fromCache) {
          state.cache[cacheKey] = data;
        }
        state.rewardList = data;
         // ✅ Page handling
         state.currentPage = page;

      // ✅ IMPORTANT: Calculate total pages from count
        const totalCount = data?.pagination?.count || 0;
        state.totalPages = Math.ceil(totalCount / pageSize);

        state.search = search;
        state.pageSize = pageSize;
        state.status = "succeeded";

      })
      .addCase(fetchReward.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Add Reward
      .addCase(addReward.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addReward.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addReward.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Update Reward
      .addCase(updateReward.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateReward.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateReward.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError , setPage, setPageSize , clearCache } = rewardSlice.actions;

export default rewardSlice.reducer;